/**
 * 元素鼠标悬浮添加动画
 * v-hoveranimate="'animate__headShake'"
 */
export default {
    bind(el, binding) {
        if (binding.value) {
            el.className = el.className + ' animate__animated';

            el.onmouseenter = function() {
                el.className = el.className + ' ' +  binding.value;
            }

            el.onmouseleave = function() {
                el.className = el.className.substring(0, el.className.length - binding.value.length)
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/directive/hoveranimate.js